export default __webpack_public_path__ + "static/media/product-image-7.48005e55.jpg";